import * as React from "react";

const baseCls = "rj-yourbet__btn";

export class Button extends React.Component<{
    modifier?: string
    disabled?: boolean
    handler: (e: React.MouseEvent<HTMLButtonElement>) => void
}, {}> {
    render() {
        const mdfr = this.props.modifier ? ` ${baseCls}--${this.props.modifier}` : "";
        const dataUat = this.props.modifier ? `-${this.props.modifier}` : "";
        return (
            <button className={`${baseCls}${mdfr}`} data-uat={`your-bet-btn${dataUat}`} onClick={this.props.handler} disabled={this.props.disabled}>
                <span className={`${baseCls}-inner`} data-uat="your-bet-btn-name">
                    {this.props.children}
                </span>
            </button>
        )
    }
}